// ** UI
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

// ** Components
import Section from '@/components/common/Section';
import ComponentElementsPersonCard from '@/components/strapi/Elements/ComponentElementsPersonCard';

// ** Type
import type { StrapiComponentProps } from '@/types/strapi';
import type { ComponentBlocksCardsRow as BlocksCardsRow } from '@/types/graphql';

type ComponentBlocksCardsRowProps = StrapiComponentProps<BlocksCardsRow>;

// Cards Row Block — person cards laid out 4-per-row like the Team block, left-aligned with the section title
const ComponentBlocksCardsRow = ({
	host,
	containerSx,
	cardsRowSectionTitle,
	cardsRowContent = []
}: ComponentBlocksCardsRowProps) => {
	return (
		<Section containerSx={containerSx}>
			{cardsRowSectionTitle && (
				<Typography
					variant="title-lg"
					component="h2"
					sx={{
						mb: 10,
						color: 'common.black',
						fontSize: { xs: '2rem', md: '2.5rem' },
						lineHeight: { xs: '2.5rem', md: '3rem' },
						letterSpacing: { xs: '-0.64px', md: '-1.2px' }
					}}
				>
					{cardsRowSectionTitle}
				</Typography>
			)}

			<Grid container spacing={{ xs: 4, md: 6 }}>
				{cardsRowContent.map((item) => {
					if (!item) return null;
					return (
						<Grid key={item?.id} size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
							<ComponentElementsPersonCard host={host} {...item} />
						</Grid>
					);
				})}
			</Grid>
		</Section>
	);
};

export default ComponentBlocksCardsRow;
